import { UserSecret } from "@/icons/UserSecret.tsx";
import useUserStore from "@/store/user.store.ts";
import { memo } from "react";
import { ActionIcon } from "@mantine/core";
import { useNavigate } from "react-router";

export const ImpersonationButton = memo(function ImpersonationButton() {
  const navigate = useNavigate();
  const { exitImpersonation, isImpersonating } = useUserStore();

  const impersonatingUserId = localStorage.getItem("impersonating_user_id");

  if (!isImpersonating) {
    if (impersonatingUserId) {
      localStorage.removeItem("impersonating_user_id");
    }
    return null;
  }

  const handleExitImpersonation = () => {
    exitImpersonation();
    navigate(0);
  };

  return (
    <ActionIcon
      onClick={handleExitImpersonation}
      variant="outline"
      size="lg"
      color="pink"
      aria-label="Exit impersonation"
    >
      <UserSecret />
    </ActionIcon>
  );
});
